<input
    type="text"
    class="form-control"
    #datePicker
    bsDaterangepicker
    [bsValue]="lastDates"
    (bsValueChange)="setDate($event)"
    [bsConfig]="bsConfig"
/>
